import { Link, NavLink, Outlet } from "react-router-dom";
import { ReactComponent as Logo } from "../../assets/James-Hope-University-Logo.svg";
import { ReactComponent as MenuIcon } from "../../assets/menu.svg";
// import { ReactComponent as Magnifier } from "../../assets/magnifier.svg";
import { ReactComponent as Envelope } from "../../assets/envelope.svg";
import { ReactComponent as Phone } from "../../assets/phone.svg";
import { ReactComponent as Linkedin } from "../../assets/linkedin.svg";
import { ReactComponent as Facebook } from "../../assets/facebook.svg";
import { ReactComponent as Youtube } from "../../assets/youtube.svg";
import { ReactComponent as Twitter } from "../../assets/twitter.svg";
import { ReactComponent as Instagram } from "../../assets/instagram.svg";
import styles from "./styles.module.scss";
import { Fragment } from "react/jsx-runtime";
import classNames from "classnames";
import { routes } from "../../routes";
import { Drawer } from "antd";
import { useState } from "react";

const ClientLayout = () => {
  const [open, setOpen] = useState(false);

  const showDrawer = () => {
    setOpen((prevState) => !prevState);
  };

  const onClose = () => {
    setOpen((prevState) => !prevState);
  };

  return (
    <main id="container" className={styles.container}>
      <header>
        <nav className={styles.header}>
          <Link to={"/"}>
            <Logo />
          </Link>

          <ul className={styles.links}>
            <li>
              <NavLink to={"/admission"}>
                {({ isActive }) => (
                  <>
                    <span>Admission</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li>
              <NavLink to={"/student-life"}>
                {({ isActive }) => (
                  <>
                    <span>Student Life</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li>
              <NavLink to={"/about-us"}>
                {({ isActive }) => (
                  <>
                    <span>About Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li>
              <NavLink to={"/contact-us"}>
                {({ isActive }) => (
                  <>
                    <span>Contact Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li>
              <NavLink to={routes.auth.login}>
                {({ isActive }) => (
                  <>
                    <span>Login</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>
          </ul>
          {/* <div className={styles.search}>
            <Magnifier />
            <input type="text" placeholder="Type here..." />
          </div> */}

          <MenuIcon className={styles.menu} onClick={showDrawer} />
        </nav>

        <Drawer onClose={onClose} open={open}>
          <ul className={styles.sideLink}>
            <li onClick={onClose}>
              <NavLink to={"/admission"}>
                {({ isActive }) => (
                  <>
                    <span>Admission</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li onClick={onClose}>
              <NavLink to={"/student-life"}>
                {({ isActive }) => (
                  <>
                    <span>Student Life</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li onClick={onClose}>
              <NavLink to={"/about-us"}>
                {({ isActive }) => (
                  <>
                    <span>About Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li onClick={onClose}>
              <NavLink to={"/contact-us"}>
                {({ isActive }) => (
                  <>
                    <span>Contact Us</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>

            <li onClick={onClose}>
              <NavLink to={routes.auth.login}>
                {({ isActive }) => (
                  <>
                    <span>Login</span>
                    {isActive ? (
                      <span className={styles.linkLine}></span>
                    ) : null}
                    <span className={styles.linkHover}></span>
                  </>
                )}
              </NavLink>
            </li>
          </ul>
        </Drawer>

        <nav className={styles.contact}>
          <section className={styles.smallGap}>
            <p>Any questions?</p>
            <div className="small-gap">
              <Envelope />
              <span>enquiries:registrar@fcetasaba.edu.ng</span>
            </div>

            <div className="small-gap">
              <Phone />
              <span>056280331, 056280331 </span>
            </div>
          </section>

          {/* <section className="small-gap">
            <Link to={"/"}>Apply Now</Link>
            <Link to={"/"}>Download our brochure</Link>
          </section> */}
        </nav>
      </header>

      <div>
        <Outlet />
      </div>

      <footer className={styles.footer}>
        <section
          className={classNames(styles.footerLinks, "space-between flex-start")}
        >
          {footerLinks.map((link) => (
            <div key={link.title}>
              <h4>{link.title}</h4>

              <ul>
                {link.links.map((l) => (
                  <li key={l.path}>
                    <Link
                      to={l.path}
                      // onClick={(e) => {
                      //   e.preventDefault();
                      //   handleNavigation(l.path);
                      // }}
                    >
                      {l.title}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
           <p>
            <h4>Permanent site:</h4>
            Federal College of Education (Technical)
            Asaba-Ibusa Road,
            P. M. B. 1044,
            Asaba, Delta State
            Tel: 056280331
            Fax: 056280331
            <p><h4>Email:</h4>
            provost@fcetasaba.edu.ng
            deputyprovost@fcetasaba.edu.ng
            registrar@fcetasaba.edu.ng
            bursar@fcetasaba.edu.ng
            librarian@fcetasaba.edu.ng</p>
          </p>

          {/* <p>
            James Hope University Twin Lakes Estate - Chevron Junction Lekki Epe
            Expressway Lagos +234 201 515 0401, +234 201 515 0408 Email:
            enquiries@jhu.edu.ng
          </p> */}
        </section>

        <section className={styles.footerEnd}>
          <div className="small-gap">
            {social.map((social, index) => (
              <Fragment key={index}>{social}</Fragment>
            ))}
          </div>
          <Logo />
        </section>
      </footer>
    </main>
  );
};

export default ClientLayout;

const footerLinks = [
  {
    title: "Explore",
    links: [
      { title: "Home", path: "/" },
      { title: "About", path: "/about-us#about-us" },
      // { title: "Academics", path: "/academics" },
      { title: "Admission", path: "/admission" },
      { title: "Student Life", path: "/student-life#student-life" },
    ],
  },
  {
    title: "Information For",
    links: [
      // { title: "How To Apply", path: "/how-to-apply" },
      { title: "Campus Experience", path: "/student-life#campus-experience" },
      { title: "Student Activities", path: "/student-life#student-activities" },
      { title: "Support & Guidance", path: "/student-life#support-guidance" },
      { title: "Fitness & Athletics", path: "/student-life#fitness-athletics" },
    ],
  },
  {
    title: "Student And Staff",
    links: [
      { title: "Apply Now", path: "/admission#admission" },
      // { title: "Student Portal", path: "/student-portal" },
      // { title: "Teachers", path: "/teachers" },
      // { title: "Alumni Club", path: "/alumni-club" },
      { title: "Blog", path: "/student-life#student-life" },
    ],
  },
];

const social = [
  <Linkedin />,
  <Facebook />,
  <Youtube />,
  <Twitter />,
  <Instagram />,
];
